import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ResourceType, ResourceUtils} from "../../../models/resource";
import {SettingsManagerService} from "../../../services/settings-manager.service";
import {UiManagerService} from "../../../services/ui-manager.service";
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {MatChipInputEvent} from "@angular/material/chips";

export interface EditResourceDialogData {
  isNew: boolean;
  name: string;
  file?: File;
  tags: string[];
  uploadableResources?: ResourceType[];
}

@Component({
  selector: 'app-edit-resource-dialog',
  templateUrl: './edit-resource-dialog.component.html',
  styleUrls: ['./edit-resource-dialog.component.scss']
})
export class EditResourceDialogComponent implements OnInit {

  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  constructor(
    private settingsManagerService: SettingsManagerService,
    private uiManagerService: UiManagerService,
    public dialogRef: MatDialogRef<EditResourceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditResourceDialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

  getAcceptMimeType() {
    return ResourceUtils.ResourceTypesToContentType(this.data.uploadableResources).replace('model/gltf-binary', '.gltf,.glb')
  }

  async checkFile() {

    // Check upload size
    const {size, type} = ResourceUtils.GetFileMetadata(this.data.file);
    if (
      (type == ResourceType.VIDEO && size > await this.settingsManagerService.getVideoMaxUploadSize()) ||
      (type != ResourceType.VIDEO && size > await this.settingsManagerService.getFileMaxUploadSize())
    ) {

      // File not valid

      if (type == ResourceType.VIDEO) {
        this.uiManagerService.showInfoDialog('Resource upload', `Max upload size reached: ${await this.settingsManagerService.getVideoMaxUploadSize() / 1024 / 1024}MB`);
      } else {
        this.uiManagerService.showInfoDialog('Resource upload', `Max upload size reached: ${await this.settingsManagerService.getFileMaxUploadSize() / 1024 / 1024}MB`);
      }

      this.data.file = null;

    }

    // File is valid -> nothing to do

  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add
    if (value) {
      this.data.tags.push(value);
    }

    // Clear the input value
    event.input.value = "";
  }

  remove(tag: string): void {
    const index = this.data.tags.indexOf(tag);
    if (index >= 0) {
      this.data.tags.splice(index, 1);
    }
  }

}
